export * from './client.service';
export * from './report.service';
export * from './consult_form.service';
export * from './user.service';
export * from './consult_history.service';

export const BASE_API_URL = process.env.VUE_APP_API_URL
export const BACKEND_URL = BASE_API_URL.replace('/api', '')
